import React from 'react'
import Yup from './../../../helpers/custom-yup'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import PropTypes from 'prop-types'
import RegisterSourceService from './../../../services/register-source.service'
import { Form, Formik } from 'formik'
import {
	DateInput,
	TextInput,
	PhoneInput,
	SelectInput,
	CheckboxToggleInput,
} from '../../../components/form-components/inputs.component'

import { PRIMARY_COLOR } from '../../../styles/colors.style'

const schema = Yup.object().shape({
	isOtherSource: Yup.bool().required(),
	// gender: Yup.string().required('Informe o sexo'),
	source: Yup.string().required('Informe como você ficou sabendo do Muviflex'),
	birthday: Yup.string().birthday().required('Informe a data de nascimento'),
	phone: Yup.string().phone().required('Informe o telefone'),
	othersource: Yup.string().when(['isOtherSource'], {
		is: true,
		then: Yup.string().required(
			'Informe como você ficou sabendo do Muviflex'
		),
		otherwise: Yup.string(),
	}),
	rideApp: Yup.string().ensure(),
})

const StyledForm = styled.div`
	width: 300px;
	@media (max-width: 600px) {
		width: 100%;
	}
`

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

const StyledButtonContainer = styled.div`
	margin-top: 5rem;
	display: flex;
	justify-content: flex-end;
`

// const genderOptions = [
// 	{ value: '', label: 'Selecione...' },
// 	{ value: 'F', label: 'Feminino' },
// 	{ value: 'M', label: 'Masculino' },
// 	{ value: 'O', label: 'Outros' }
// ]

class ComplementaryForm extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			sourceOptions: [],
			isOtherSource: false,
			rideOptions: [],
		}

		this.rideRef = React.createRef()
		this.phoneRef = React.createRef()
		// this.genderRef = React.createRef()
		this.sourceRef = React.createRef()
		this.rideAppRef = React.createRef()
		this.birthdayRef = React.createRef()
		this.otherSourceRef = React.createRef()
		this.onSourceChange = onSourceChange.bind(this)
	}

	onEnter = () => {
		setTimeout(() => {
			this.birthdayRef.current.focus()
		}, 0)
	}

	componentDidMount() {
		RegisterSourceService.listRegisterSources().then(({ data }) => {
			this.setState({
				sourceOptions: data.map((item) => ({
					value: item.id,
					label: item.description,
				})),
			})
		})
	}

	addressFocus = () => {
		document.getElementById('state').focus()
		window.scrollTo(0, 250)
	}

	render() {
		const { onSubmit, onClick, onBack } = this.props
		return (
			<Formik
				ref="form"
				initialValues={{
					phone: '',
					// gender: '',
					source: '',
					birthday: '',
					isOtherSource: false,
					rideApp: false,
				}}
				onSubmit={onSubmit}
				validationSchema={schema}
				render={(props) => (
					<Form noValidate>
						<StyledForm>
							<DateInput
								id="birthday"
								label="Data de nascimento *"
								elementRef={this.birthdayRef}
								{...props}
							/>
							{/* <StyledInputContainer>
								<SelectInput
									id="gender"
									multi={false}
									label="Sexo *"
									options={genderOptions}
									placeholder="Selecione ..."
									elementRef={this.genderRef}
									{...props}
								/>
							</StyledInputContainer> */}
							<StyledInputContainer>
								<PhoneInput
									id="phone"
									label="Telefone *"
									elementRef={this.phoneRef}
									{...props}
								/>
							</StyledInputContainer>
							<StyledInputContainer>
								<SelectInput
									id="source"
									multi={false}
									elementRef={this.sourceRef}
									placeholder="Selecione ..."
									options={this.state.sourceOptions}
									onValueChange={this.onSourceChange}
									label="Como você ficou sabendo do Muviflex? *"
									{...props}
								/>
							</StyledInputContainer>
							{this.state.isOtherSource ? (
								<StyledInputContainer>
									<TextInput
										maxLength={32}
										label="Qual? *"
										id="othersource"
										elementRef={this.otherSourceRef}
										{...props}
									/>
								</StyledInputContainer>
							) : null}
							<StyledInputContainer>
								<p>
									Você utiliza ou já utilizou algum aplicativo de
									carona?
								</p>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<CheckboxToggleInput
										elementRef={this.rideRef}
										id="rideApp"
										{...props}
									/>

									<p style={{ paddingLeft: '1rem' }}>
										{props.values.rideApp ? (
											<span
												style={{
													color: PRIMARY_COLOR,
												}}>
												Sim
											</span>
										) : (
											'Não'
										)}
									</p>
								</div>
							</StyledInputContainer>
						</StyledForm>
						<StyledButtonContainer>
							<Button
								link
								type="button"
								onClick={() => onBack && onBack()}>
								Anterior
							</Button>
							<Button
								primary
								type="submit"
								onClick={() => {
									onClick && onClick(props.isValid)
									if (!props.isValid) {
										const id = Object.keys(props.errors)[0]
										const ref = this[`${id}Ref`]
										if (!ref || !ref.current) return
										ref.current.focus()
									} else {
										this.addressFocus(this.state.isOtherSource)
									}
								}}>
								Avançar
							</Button>
						</StyledButtonContainer>
					</Form>
				)}
			/>
		)
	}
}

function onSourceChange(value) {
	const isOtherSource = this.state.sourceOptions.some(
		(option) => option.value == value && option.label == 'Outro'
	)
	if (isOtherSource != this.state.isOtherSource) {
		this.setState({ isOtherSource })
		this.refs.form.setFieldValue('isOtherSource', isOtherSource)
		if (!isOtherSource) {
			this.refs.form.setFieldValue('othersource', '')
		}
	}
}

ComplementaryForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func,
}

export default ComplementaryForm
